"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Channel = void 0;
var Channel;
(function (Channel) {
    Channel["TELEPHONE"] = "telephone";
    Channel["BRIEF"] = "brief";
    Channel["RETURN_POST"] = "returnpost";
    Channel["FAX"] = "fax";
    Channel["FORMS"] = "forms";
    Channel["MIJN_ESSENT"] = "mijnessent_nl";
    Channel["MAIL_WEBFORM"] = "e-mail_webform";
    Channel["VISIT"] = "visit";
    Channel["EXTERN"] = "extern";
    Channel["OPEN_ENV_WEBFORM"] = "open_env_webform";
    Channel["CLOSED_ENV_WEBFORM"] = "closed_env_webform";
    Channel["SOCIAL_MEDIA"] = "social_media";
    Channel["INTERNAL_ADVICE"] = "intern_advice";
    Channel["SMS"] = "sms";
    Channel["CHAT"] = "chat";
    Channel["TELEFONIEBOT"] = "telefoniebot";
    Channel["CHATBOT"] = "chatbot";
})(Channel = exports.Channel || (exports.Channel = {}));
